import { ColumnState } from 'ag-grid-community';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { UserResponseDto } from 'src/dtos/user/response/userResponseDto';
import { create } from 'zustand';
import { defaultKSK2011_R01DetailDto, defaultKSK2011_R01Dto, defaultKSK2011_R01EditDto, KSK2011_R01DetailDto, KSK2011_R01Dto, KSK2011_R01EditDto } from './Dto_KSK2011_R01';
import { DateRange } from 'react-day-picker';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { calculateTotalOrderQty } from 'src/components/common/common';

export interface KSK2011_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	workplaceCd: string;
	jobTeam: string;
	closeTag: string;
	orderEmp: string;
	orderEmpNm: string;
}

export interface Store_KSK2011_R01 {
	KSK2011_R01Filter: KSK2011_R01Filter;
	KSK2011_R01PastFilter: KSK2011_R01Filter;
	setKSK2011_R01Filter: (filter: Partial<KSK2011_R01Filter>) => void;
	setKSK2011_R01PastFilter: (filter: Partial<KSK2011_R01Filter>) => void;

    KSK2011_R01List: KSK2011_R01Dto[];
    setKSK2011_R01List: (userList: KSK2011_R01Dto[]) => void;
    insertKSK2011_R01List: (data: KSK2011_R01Dto[], index?: number) => void;
    removeKSK2011_R01List: (index: number) => void;
    updateKSK2011_R01List: (index: number, data: KSK2011_R01Dto) => void;

    deletedKSK2011_R01List: string[];
    addDeletedKSK2011_R01List: (idList: string[]) => void;
    removeDeletedKSK2011_R01List: (idList?: string[]) => void;

	selectedKSK2011_R01List: KSK2011_R01Dto | undefined;
	setSelectedKSK2011_R01List: (data: KSK2011_R01Dto | undefined) => void;
	initSelectedKSK2011_R01List: () => void;

	originalKSK2011_R01List: KSK2011_R01Dto[];
	setOriginalKSK2011_R01List: (list: KSK2011_R01Dto[]) => void;
	
	editKSK2011_R01: KSK2011_R01EditDto | null;
	setEditKSK2011_R01: (editHeader: KSK2011_R01EditDto | null) => void;

    KSK2011_R01DetailList: KSK2011_R01DetailDto[];
    setKSK2011_R01DetailList: (userList: KSK2011_R01DetailDto[]) => void;
    insertKSK2011_R01DetailList: (data: KSK2011_R01DetailDto[], index?: number) => void;
    removeKSK2011_R01DetailList: (index: number) => void;
    updateKSK2011_R01DetailList: (index: number, data: KSK2011_R01DetailDto) => void;

    deletedKSK2011_R01DetailList: string[];
    addDeletedKSK2011_R01DetailList: (idList: string[]) => void;
    removeDeletedKSK2011_R01DetailList: (idList?: string[]) => void;

	selectedKSK2011_R01DetailList: KSK2011_R01DetailDto | undefined;
	setSelectedKSK2011_R01DetailList: (data: KSK2011_R01DetailDto | undefined) => void;
	initSelectedKSK2011_R01DetailList: () => void;

	originalKSK2011_R01DetailList: KSK2011_R01DetailDto[];
	setOriginalKSK2011_R01DetailList: (list: KSK2011_R01DetailDto[]) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	modalVisible: boolean;				setModalVisible: (modalVisible: boolean) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;
	
	isDisabled: (data: KSK2011_R01Dto) => boolean;

    initData: () => void;


}

export const defaultKSK2011_R01Filter: KSK2011_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	workplaceCd: '',
	jobTeam: '',
	closeTag: 'N',
	orderEmp: '',
	orderEmpNm: '',
}

export const useKSK2011_R01Store = create<Store_KSK2011_R01>((set) => ({
	KSK2011_R01Filter: defaultKSK2011_R01Filter,
	KSK2011_R01PastFilter: defaultKSK2011_R01Filter,
	setKSK2011_R01PastFilter: (filter: Partial<KSK2011_R01Filter>) => set((state) => ({
		...state,
		KSK2011_R01PastFilter: { ...state.KSK2011_R01PastFilter, ...filter }
	})),
	setKSK2011_R01Filter: (filter: Partial<KSK2011_R01Filter>) => set((state) => ({
		...state,
		KSK2011_R01Filter: { ...state.KSK2011_R01Filter, ...filter }
	})),

    KSK2011_R01List: [],
    setKSK2011_R01List: (KSK2011_R01List: KSK2011_R01Dto[]) => set((state) => {
		let newList: KSK2011_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2011_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultKSK2011_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
				disabled: state.isDisabled(item)
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2011_R01List: newList
		}
	}),
	insertKSK2011_R01List: (data: KSK2011_R01Dto[], index?: number) => set((state) => {
		let newKSK2011_R01List = [...state.KSK2011_R01List];

		let targetRowData = newKSK2011_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2011_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2011_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2011_R01List = newKSK2011_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2011_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2011_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2011_R01List.splice(index, 0, ...newData);
		} else {
			newKSK2011_R01List.push(...newData);
		}		

		return {
			...state,
			KSK2011_R01List: newKSK2011_R01List
		}
	}),
	removeKSK2011_R01List: (index: number) => set((state) => {
		const newKSK2011_R01List = [...state.KSK2011_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2011_R01List: newKSK2011_R01List
		}
	}),
	updateKSK2011_R01List: (valueIndex: number, data: KSK2011_R01Dto) => set((state) => {
		const _KSK2011_R01List = state.KSK2011_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.orderQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.orderQty = 0;
		}
		return {
			...state,
			KSK2011_R01List: _KSK2011_R01List
		}
	}),

    deletedKSK2011_R01List: [],
    addDeletedKSK2011_R01List: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedKSK2011_R01List];
		
		for(const valueIndex of idList) {
			const isInserted = state.KSK2011_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2011_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedKSK2011_R01List: _deletedUserList
        }
    }),
    removeDeletedKSK2011_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        deletedKSK2011_R01List: [...state.deletedKSK2011_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),

	selectedKSK2011_R01List: undefined,
	setSelectedKSK2011_R01List: (data: KSK2011_R01Dto | undefined) => set({ selectedKSK2011_R01List: data }),
	initSelectedKSK2011_R01List: () => set({ selectedKSK2011_R01List: undefined }),

	originalKSK2011_R01List: [],
	
    setOriginalKSK2011_R01List: (KSK2011_R01List: KSK2011_R01Dto[]) => set((state) => {
		let newList: KSK2011_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2011_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2011_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2011_R01List: newList
		}
	}),
	

	editKSK2011_R01: defaultKSK2011_R01EditDto,
	setEditKSK2011_R01: (editHeader: KSK2011_R01EditDto | null) => set((state) => {
		//editHeader.orderQty값의 변경을 감지해서 detailList에서 totalOrderQty를 계산
		const KSK2011_R01DetailList = state.KSK2011_R01DetailList.map(item => {
			if (editHeader) {
				const totalOrderQty = calculateTotalOrderQty(editHeader.orderQty, item.childItemUsage, item.lossPercent, item.fixLossqty) || 0;
				return {
					...item,
					totalOrderQty,
					shortageQty: item.productWarehouseQty - totalOrderQty
				};
			}
			return item;
		});

		return {
			...state,
			editKSK2011_R01: editHeader,
			KSK2011_R01DetailList: KSK2011_R01DetailList
		};
	}),

	
    KSK2011_R01DetailList: [],
    setKSK2011_R01DetailList: (KSK2011_R01DetailList: KSK2011_R01DetailDto[]) => set((state) => {
		let newList: KSK2011_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		KSK2011_R01DetailList.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultKSK2011_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2011_R01DetailList: newList
		}
	}),
	insertKSK2011_R01DetailList: (data: KSK2011_R01DetailDto[], index?: number) => set((state) => {
		let newKSK2011_R01DetailList = [...state.KSK2011_R01DetailList];

		let targetRowData = newKSK2011_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2011_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2011_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2011_R01DetailList = newKSK2011_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2011_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2011_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2011_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK2011_R01DetailList.push(...newData);
		}		

		return {
			...state,
			KSK2011_R01DetailList: newKSK2011_R01DetailList
		}
	}),
	removeKSK2011_R01DetailList: (index: number) => set((state) => {
		const newKSK2011_R01DetailList = [...state.KSK2011_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2011_R01DetailList: newKSK2011_R01DetailList
		}
	}),
	updateKSK2011_R01DetailList: (valueIndex: number, data: KSK2011_R01DetailDto) => set((state) => {
		const _KSK2011_R01DetailList = state.KSK2011_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			KSK2011_R01DetailList: _KSK2011_R01DetailList
		}
	}),

    deletedKSK2011_R01DetailList: [],
    addDeletedKSK2011_R01DetailList: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedKSK2011_R01DetailList];
		
		for(const valueIndex of idList) {
			const isInserted = state.KSK2011_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2011_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedKSK2011_R01DetailList: _deletedUserList
        }
    }),
    removeDeletedKSK2011_R01DetailList: (idList?: string[]) => set((state) => ({
        ...state,
        deletedKSK2011_R01DetailList: [...state.deletedKSK2011_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
    })),

	selectedKSK2011_R01DetailList: undefined,
	setSelectedKSK2011_R01DetailList: (data: KSK2011_R01DetailDto | undefined) => set({ selectedKSK2011_R01DetailList: data }),
	initSelectedKSK2011_R01DetailList: () => set({ selectedKSK2011_R01DetailList: undefined }),

	originalKSK2011_R01DetailList: [],
	
    setOriginalKSK2011_R01DetailList: (KSK2011_R01DetailList: KSK2011_R01DetailDto[]) => set((state) => {
		let newList: KSK2011_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		KSK2011_R01DetailList.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2011_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2011_R01DetailList: newList
		}
	}),

    columnState: null,
    setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,				setAllCount: (allCount: number) => set({ allCount }),
	modalVisible: false,		setModalVisible: (modalVisible: boolean) => set({ modalVisible }),
	detailFetchTrigger: false,	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	isDisabled: (data: KSK2011_R01Dto) => data.closeTag === 'Y' || data.resultQty > 0,

    initData: () => set((state) => ({
        ...state,
		KSK2011_R01Filter: defaultKSK2011_R01Filter,
		KSK2011_R01PastFilter: defaultKSK2011_R01Filter,
        KSK2011_R01List: [],
        selectedKSK2011_R01List: undefined,
        deletedKSK2011_R01List: [],
		KSK2011_R01DetailList: [],
        selectedKSK2011_R01DetailList: undefined,
        deletedKSK2011_R01DetailList: [],
		allCount: 0
    }))
}));